import Container from "react-bootstrap/Container";
import Carousel from "react-bootstrap/Carousel";
import Divider from "../components/Divider";
import React, { useState, useEffect, useRef } from "react";
import { CarouselArrow } from "../components/CarouselArrows";
import anime from 'animejs';
import "./Gallery.css";

function Gallery() {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isVisible, setIsVisible] = useState(false);
    const titleRef = useRef(null);
    const subtitleRef = useRef(null);
    const carouselRef = useRef(null);
    
    const imagesContext = require.context('../../public/images/carousel', false, /\.(png|jpe?g|svg)$/);
    const images = imagesContext.keys().map(imagesContext);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !isVisible) {
                    setIsVisible(true);
                    
                    // Title animation
                    anime({
                        targets: titleRef.current,
                        translateY: [50, 0],
                        opacity: [0, 1],
                        easing: 'easeOutExpo',
                        duration: 1200,
                        delay: 200,
                    });

                    // Subtitle animation
                    anime({
                        targets: subtitleRef.current,
                        translateY: [30, 0],
                        opacity: [0, 1],
                        easing: 'easeOutExpo',
                        duration: 1200,
                        delay: 500,
                    });

                    // Carousel animation
                    anime({
                        targets: carouselRef.current,
                        translateY: [30, 0],
                        opacity: [0, 1],
                        easing: 'easeOutExpo',
                        duration: 1200,
                        delay: 800,
                    });

                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.1
        });

        observer.observe(titleRef.current);
        observer.observe(subtitleRef.current);
        observer.observe(carouselRef.current);

        return () => observer.disconnect();
    }, [isVisible]);

    const getImageHeight = () => {
        if (windowWidth < 576) return 250;
        if (windowWidth < 768) return 350;
        if (windowWidth < 992) return 450;
        return 500;
    };

    return (
        <div className="gallery-section" id="gallery">
            <Container fluid className="px-4 px-md-5">
                <div className="gallery-header text-center">
                    <h2 className={`section-title ${isVisible ? 'visible' : ''}`} ref={titleRef}>Εικόνες</h2>
                    <p className={`section-subtitle ${isVisible ? 'visible' : ''}`} ref={subtitleRef}>
                        Εξερευνήστε την όμορφη συλλογή μας στην οποία αναπαράγουμε την ομορφιά της φύσης μέσω των δέντρων.
                    </p>
                </div>

                <div className="gallery-content" ref={carouselRef}>
                    <Carousel 
                        fade 
                        interval={5000} 
                        controls={true}
                        indicators={true}
                        className="gallery-carousel"
                        pause="hover"
                        prevIcon={<CarouselArrow direction="prev" />}
                        nextIcon={<CarouselArrow direction="next" />}
                    >
                        {images.map((image, index) => (
                            <Carousel.Item key={index}>
                                <div className="gallery-image-container" style={{ height: getImageHeight() }}>
                                    <img
                                        className="d-block w-100 gallery-image"
                                        src={image}
                                        alt={`${index + 1}`}
                                        loading="lazy"
                                    />
                                </div>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                </div>
            </Container>
            <Divider/>
        </div>
    );
}

export default Gallery;